enum DimensionMask {
  RADIAL = '000/00/R00/00[0]/A',
  PERFORMANCE = '000/00/ZR00/00[0]/A',
  DOUBLE_LOAD = '000/00/R00/00[0]/00[0]/A'
}

export default DimensionMask;